import { Subject } from 'rxjs'

import { MapPosition } from '@/domain/protocols/MapPosition'

const MapClickEvent = new Subject<MapPosition>()
const MapClickEventFromMeasuringSegment = new Subject<MapPosition>()
const MapMouseMoveEvent = new Subject<MapPosition>()

export { MapClickEvent, MapClickEventFromMeasuringSegment, MapMouseMoveEvent }
